import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { queryClient } from "./lib/queryClient";

import Home from "./pages/Home";
import Login from "./pages/Login";
import Register from "./pages/Register";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";
import ScanResults from "./pages/ScanResults";
import ScansPage from "./pages/ScansPage";
import Profile from "./pages/Profile";
import MissionFile from "./pages/MissionFile";
import NotFound from "./pages/NotFound";

import AuthCallback from "./pages/AuthCallback";
import ErrorBoundary from "./components/ErrorBoundary";

import "./App.css";

/**
 * Main App Component
 *
 * Provides:
 * - React Query integration for data fetching and caching
 * - React Router for navigation
 * - Error boundary for graceful error handling
 * - Development tools (React Query DevTools)
 */
function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <Router>
        <ErrorBoundary>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/login" element={<Login />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/auth/callback" element={<AuthCallback />} />
            <Route path="/scans" element={<ScansPage />} />
            <Route path="/scan/:scanId" element={<ScanResults />} />
            <Route path="/register" element={<Register />} />
            <Route path="/profile" element={<Profile />} />
            <Route path="/mission-file" element={<MissionFile />} />

            <Route path="*" element={<NotFound />} />
          </Routes>
        </ErrorBoundary>
      </Router>
      
      {/* React Query DevTools - only in development */}
      {process.env.NODE_ENV === 'development' && (
        <ReactQueryDevtools initialIsOpen={false} position="bottom-right" />
      )}
    </QueryClientProvider>
  );
}

export default App;
